export const SWAGGER_UI_FIX_STYLES = `
  .swagger-page-scope .swagger-ui {
    --fluent-bg-page: #f5f5f5;
    --fluent-bg-card: #ffffff;
    --fluent-bg-subtle: #fafafa;
    --fluent-bg-hover: #f3f2f1;
    --fluent-text-primary: #242424;
    --fluent-text-secondary: #605e5c;
    --fluent-border: #e1dfdd;
    --fluent-border-strong: #c8c6c4;
    --fluent-brand: #0f6cbd;
    --fluent-brand-hover: #115ea3;
    --fluent-brand-pressed: #0f548c;
    --fluent-neutral-bg-hover: #f3f2f1;
    --fluent-neutral-bg-pressed: #edebe9;
    --fluent-neutral-bg-disabled: #f5f5f5;
    --fluent-neutral-text-disabled: #a19f9d;
    --fluent-success-bg: #f1faf1;
    --fluent-success-border: #6bb700;
    --fluent-warning-bg: #fff9f5;
    --fluent-warning-border: #f59e0b;
    --fluent-danger-bg: #fff5f5;
    --fluent-danger-border: #d13438;
    --fluent-radius-sm: 4px;
    --fluent-radius-md: 8px;
    --fluent-radius-lg: 10px;
    --fluent-shadow-card: 0 1px 2px rgba(0, 0, 0, 0.05);

    padding: 0 12px 12px;
    box-sizing: border-box;
    color: var(--fluent-text-primary);
    background: var(--fluent-bg-page);
    font-family: 'Segoe UI Variable Text', 'Segoe UI', system-ui, sans-serif;
  }

  .swagger-page-scope .swagger-ui .information-container {
    padding-top: 12px;
  }

  .swagger-page-scope .swagger-ui .info {
    margin: 0 0 14px;
    padding: 12px 14px;
    border: 1px solid var(--fluent-border);
    border-radius: var(--fluent-radius-lg);
    background: var(--fluent-bg-card);
    box-shadow: var(--fluent-shadow-card);
  }

  .swagger-page-scope .swagger-ui .info .swagger-info-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }

  .swagger-page-scope .swagger-ui .info .swagger-info-header hgroup.main {
    flex: 1 1 auto;
    margin: 0;
  }

  .swagger-page-scope .swagger-ui .info .swagger-title-controls {
    flex: 0 0 auto;
    min-width: 0;
  }

  .swagger-page-scope .swagger-ui .info .swagger-title-controls .scheme-container {
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    background: transparent;
  }

  .swagger-page-scope .swagger-ui .info .swagger-title-controls .scheme-container .schemes {
    gap: 8px;
    justify-content: flex-end;
    align-items: center;
  }

  .swagger-page-scope .swagger-ui .info .swagger-title-controls .scheme-container .schemes-server-container {
    flex: 0 1 auto;
  }

  .swagger-page-scope .swagger-ui .info .swagger-title-controls .scheme-container .schemes-server-container label {
    margin: 0;
  }

  .swagger-page-scope .swagger-ui .info .swagger-title-controls .scheme-container select {
    max-width: 220px;
  }

  .swagger-page-scope .swagger-ui .info hgroup.main {
    margin-bottom: 6px;
  }

  .swagger-page-scope .swagger-ui .info .title {
    display: block;
    margin-bottom: 6px;
    line-height: 1.25;
    color: var(--fluent-text-primary);
    font-size: 22px;
    font-weight: 700;
  }

  .swagger-page-scope .swagger-ui .info .title small {
    display: inline-block;
    vertical-align: middle;
  }

  .swagger-page-scope .swagger-ui .info .base-url {
    display: block;
    position: static;
    margin-top: 4px;
    margin-left: 0;
    clear: both;
    color: var(--fluent-text-secondary);
    font-size: 12px;
    word-break: break-all;
  }

  .swagger-page-scope .swagger-ui .info p,
  .swagger-page-scope .swagger-ui .info li,
  .swagger-page-scope .swagger-ui .info table {
    color: var(--fluent-text-secondary);
  }

  .swagger-page-scope .swagger-ui .scheme-container {
    margin: 0 0 12px;
    padding: 10px 12px;
    box-sizing: border-box;
    overflow: hidden;
    border: 1px solid var(--fluent-border);
    border-radius: var(--fluent-radius-lg);
    box-shadow: var(--fluent-shadow-card);
    background: var(--fluent-bg-card);
  }

  .swagger-page-scope .swagger-ui .scheme-container .schemes {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
  }

  .swagger-page-scope .swagger-ui .scheme-container .schemes > .schemes-server-container > label {
    display: flex;
    flex-direction: column;
    margin: 0;
    min-width: 0;
  }

  .swagger-page-scope .swagger-ui .scheme-container .schemes .schemes-title {
    display: block;
    margin-bottom: 2px;
    color: var(--fluent-text-secondary);
    font-size: 12px;
    font-weight: 600;
  }

  .swagger-page-scope .swagger-ui .scheme-container .schemes > .schemes-server-container {
    display: flex;
    flex: 1 1 260px;
    flex-wrap: wrap;
    gap: 8px;
    min-width: 0;
  }

  .swagger-page-scope .swagger-ui .scheme-container .schemes > .schemes-server-container > label select {
    min-width: 0;
    width: 100%;
    max-width: 240px;
  }

  .swagger-page-scope .swagger-ui .scheme-container .schemes .auth-wrapper {
    display: flex;
    flex: 0 1 auto;
    justify-content: flex-start;
    min-width: 0;
  }

  .swagger-page-scope .swagger-ui .scheme-container .schemes .auth-wrapper .authorize {
    margin: 0;
    padding-right: 0;
  }

  .swagger-page-scope .swagger-ui .opblock-tag,
  .swagger-page-scope .swagger-ui .opblock .opblock-summary,
  .swagger-page-scope .swagger-ui .opblock .opblock-summary-path,
  .swagger-page-scope .swagger-ui .opblock .opblock-summary-description,
  .swagger-page-scope .swagger-ui .parameter__name,
  .swagger-page-scope .swagger-ui .response-col_status,
  .swagger-page-scope .swagger-ui .response-col_description,
  .swagger-page-scope .swagger-ui .tab li,
  .swagger-page-scope .swagger-ui section.models h4,
  .swagger-page-scope .swagger-ui label,
  .swagger-page-scope .swagger-ui input,
  .swagger-page-scope .swagger-ui select,
  .swagger-page-scope .swagger-ui textarea,
  .swagger-page-scope .swagger-ui button,
  .swagger-page-scope .swagger-ui .btn,
  .swagger-page-scope .swagger-ui .markdown p,
  .swagger-page-scope .swagger-ui .renderedMarkdown p {
    font-family: 'Segoe UI Variable Text', 'Segoe UI', system-ui, sans-serif;
  }

  .swagger-page-scope .swagger-ui input,
  .swagger-page-scope .swagger-ui textarea {
    min-height: 34px;
    border: 1px solid var(--fluent-border-strong);
    border-radius: var(--fluent-radius-sm);
    box-shadow: none;
    color: var(--fluent-text-primary);
    background: #fff;
    padding: 0 9px;
  }

  .swagger-page-scope .swagger-ui textarea,
  .swagger-page-scope .swagger-ui .body-param textarea,
  .swagger-page-scope .swagger-ui textarea.body-param__text {
    min-height: 92px !important;
    height: auto !important;
    line-height: 1.45;
    padding: 8px 10px;
    resize: vertical;
  }

  .swagger-page-scope .swagger-ui select {
    min-height: 30px;
    border: 1px solid var(--fluent-border-strong);
    border-radius: var(--fluent-radius-sm);
    box-shadow: none;
    color: var(--fluent-text-primary);
    background: #fff;
    padding: 0 9px;
  }

  .swagger-page-scope .swagger-ui select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding-right: 30px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath d='M2.5 3.5L5 6L7.5 3.5' fill='none' stroke='%23605e5c' stroke-width='1.35' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-position: calc(100% - 10px) center;
    background-size: 10px 10px;
    background-repeat: no-repeat;
    cursor: pointer;
  }

  .swagger-page-scope .swagger-ui input:focus,
  .swagger-page-scope .swagger-ui select:focus,
  .swagger-page-scope .swagger-ui textarea:focus {
    border-color: var(--fluent-brand);
    outline: 2px solid transparent;
    box-shadow: 0 0 0 1px var(--fluent-brand);
  }

  .swagger-page-scope .swagger-ui .btn,
  .swagger-page-scope .swagger-ui .authorize,
  .swagger-page-scope .swagger-ui .auth-btn-wrapper .btn,
  .swagger-page-scope .swagger-ui .download-url-wrapper .btn {
    border: 1px solid var(--fluent-border-strong);
    border-radius: var(--fluent-radius-sm);
    background: #fff;
    color: var(--fluent-text-primary);
    font-family: 'Segoe UI Variable Text', 'Segoe UI', system-ui, sans-serif;
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    min-height: 30px;
    padding: 0 10px;
    transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;
    box-shadow: none;
  }

  .swagger-page-scope .swagger-ui .btn:hover,
  .swagger-page-scope .swagger-ui .authorize:hover {
    border-color: var(--fluent-border-strong);
    background: var(--fluent-neutral-bg-hover);
    color: var(--fluent-text-primary);
  }

  .swagger-page-scope .swagger-ui .btn:active,
  .swagger-page-scope .swagger-ui .authorize:active {
    border-color: var(--fluent-border-strong);
    background: var(--fluent-neutral-bg-pressed);
  }

  .swagger-page-scope .swagger-ui .btn:focus-visible,
  .swagger-page-scope .swagger-ui .authorize:focus-visible {
    outline: 2px solid var(--fluent-brand);
    outline-offset: 1px;
  }

  .swagger-page-scope .swagger-ui .btn:disabled,
  .swagger-page-scope .swagger-ui .authorize:disabled,
  .swagger-page-scope .swagger-ui .btn.disabled {
    border-color: var(--fluent-border);
    background: var(--fluent-neutral-bg-disabled);
    color: var(--fluent-neutral-text-disabled);
    cursor: not-allowed;
    opacity: 1;
  }

  .swagger-page-scope .swagger-ui .opblock-summary-control,
  .swagger-page-scope .swagger-ui .opblock-control-arrow,
  .swagger-page-scope .swagger-ui .expand-operation,
  .swagger-page-scope .swagger-ui .expand-methods,
  .swagger-page-scope .swagger-ui .model-toggle,
  .swagger-page-scope .swagger-ui .models-control {
    border: none;
    background: transparent;
    min-height: unset;
    padding: 0;
    box-shadow: none;
  }

  .swagger-page-scope .swagger-ui .btn.execute {
    border-color: var(--fluent-brand);
    background: var(--fluent-brand);
    color: #fff;
    font-weight: 600;
  }

  .swagger-page-scope .swagger-ui .btn.execute:hover {
    border-color: var(--fluent-brand-hover);
    background: var(--fluent-brand-hover);
    color: #fff;
  }

  .swagger-page-scope .swagger-ui .btn.execute:active {
    border-color: var(--fluent-brand-pressed);
    background: var(--fluent-brand-pressed);
    color: #fff;
  }

  .swagger-page-scope .swagger-ui .btn.try-out__btn,
  .swagger-page-scope .swagger-ui .btn.cancel {
    border-color: var(--fluent-border-strong);
    color: var(--fluent-text-primary);
    background: #fff;
  }

  .swagger-page-scope .swagger-ui .auth-wrapper .authorize {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 32px;
    padding: 0 14px;
    border: 1px solid var(--fluent-border-strong);
    border-radius: var(--fluent-radius-sm);
    background: #ffffff;
    color: var(--fluent-text-primary);
    font-family: 'Segoe UI Variable Text', 'Segoe UI', system-ui, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;
  }

  .swagger-page-scope .swagger-ui .auth-wrapper .authorize:hover {
    border-color: var(--fluent-border-strong);
    background: var(--fluent-bg-hover);
    color: var(--fluent-text-primary);
  }

  .swagger-page-scope .swagger-ui .auth-wrapper .authorize:active {
    border-color: var(--fluent-border-strong);
    background: #edebe9;
  }

  .swagger-page-scope .swagger-ui .auth-wrapper .authorize:focus-visible {
    outline: 2px solid var(--fluent-brand);
    outline-offset: 1px;
  }

  .swagger-page-scope .swagger-ui .auth-wrapper .authorize svg {
    display: none;
  }

  .swagger-page-scope .swagger-ui .auth-wrapper .authorize::before {
    content: '';
    width: 12px;
    height: 12px;
    flex: 0 0 auto;
    transform: translateY(-0.5px);
    background-color: currentColor;
    -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M4.5 7V5a3.5 3.5 0 0 1 7 0v2h.75A1.75 1.75 0 0 1 14 8.75v4.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-4.5C2 7.78 2.78 7 3.75 7H4.5Zm1 0h5V5a2.5 2.5 0 0 0-5 0v2Z'/%3E%3C/svg%3E");
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
    mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M4.5 7V5a3.5 3.5 0 0 1 7 0v2h.75A1.75 1.75 0 0 1 14 8.75v4.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-4.5C2 7.78 2.78 7 3.75 7H4.5Zm1 0h5V5a2.5 2.5 0 0 0-5 0v2Z'/%3E%3C/svg%3E");
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
  }

  .swagger-page-scope .swagger-ui .authorization__btn {
    border: none;
    background: transparent;
    min-height: auto;
    min-width: auto;
    padding: 2px;
    margin: 0;
    border-radius: 3px;
    color: var(--fluent-text-secondary);
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .swagger-page-scope .swagger-ui .authorization__btn:hover {
    background: var(--fluent-neutral-bg-hover);
    color: var(--fluent-text-primary);
  }

  .swagger-page-scope .swagger-ui .authorization__btn:focus-visible {
    outline: 2px solid var(--fluent-brand);
    outline-offset: 1px;
  }

  .swagger-page-scope .swagger-ui .authorization__btn svg {
    width: 14px;
    height: 14px;
    display: block;
    fill: currentColor;
  }

  .swagger-page-scope .swagger-ui .opblock {
    border-radius: var(--fluent-radius-md);
    overflow: hidden;
    box-shadow: var(--fluent-shadow-card);
    border-width: 1px;
    border-style: solid;
    margin: 0 0 8px;
  }

  .swagger-page-scope .swagger-ui .opblock .opblock-summary {
    min-height: 42px;
    border-bottom-color: var(--fluent-border);
    align-items: center;
    padding-right: 8px;
  }

  .swagger-page-scope .swagger-ui .opblock .opblock-summary-method {
    min-width: 64px;
    border-radius: var(--fluent-radius-sm);
    font-size: 12px;
    letter-spacing: 0.2px;
    font-weight: 700;
  }

  .swagger-page-scope .swagger-ui .opblock .opblock-summary-path {
    color: var(--fluent-text-primary);
    font-size: 12px;
    font-weight: 600;
  }

  .swagger-page-scope .swagger-ui .opblock .opblock-summary-description {
    color: var(--fluent-text-secondary);
    font-size: 12px;
  }

  .swagger-page-scope .swagger-ui .opblock.opblock-get {
    background: var(--fluent-success-bg);
    border-color: rgba(16, 124, 16, 0.28);
  }

  .swagger-page-scope .swagger-ui .opblock.opblock-post {
    background: #f3f8ff;
    border-color: rgba(15, 108, 189, 0.3);
  }

  .swagger-page-scope .swagger-ui .opblock.opblock-put,
  .swagger-page-scope .swagger-ui .opblock.opblock-patch {
    background: var(--fluent-warning-bg);
    border-color: rgba(188, 92, 0, 0.3);
  }

  .swagger-page-scope .swagger-ui .opblock.opblock-delete {
    background: var(--fluent-danger-bg);
    border-color: rgba(209, 52, 56, 0.3);
  }

  .swagger-page-scope .swagger-ui .opblock-body {
    background: var(--fluent-bg-card);
  }

  .swagger-page-scope .swagger-ui table tbody tr td,
  .swagger-page-scope .swagger-ui table thead tr th {
    border-color: var(--fluent-border);
  }

  .swagger-page-scope .swagger-ui table thead tr th {
    color: var(--fluent-text-secondary);
    font-size: 12px;
    text-transform: none;
    font-weight: 600;
  }

  .swagger-page-scope .swagger-ui .responses-inner h4,
  .swagger-page-scope .swagger-ui .responses-inner h5,
  .swagger-page-scope .swagger-ui .opblock-section-header h4 {
    color: var(--fluent-text-primary);
    font-weight: 700;
  }

  .swagger-page-scope .swagger-ui section.models,
  .swagger-page-scope .swagger-ui .model-box {
    border: 1px solid var(--fluent-border);
    background: var(--fluent-bg-card);
    box-shadow: var(--fluent-shadow-card);
  }

  .swagger-page-scope .swagger-ui .model-box,
  .swagger-page-scope .swagger-ui section.models {
    border-radius: var(--fluent-radius-md);
  }

  .swagger-page-scope .swagger-ui .dialog-ux .modal-ux {
    max-width: 720px;
    border: 1px solid var(--fluent-border);
    border-radius: var(--fluent-radius-lg);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  }

  .swagger-page-scope .swagger-ui .dialog-ux .modal-ux-header {
    border-bottom: 1px solid var(--fluent-border);
    padding: 14px 20px;
    background: var(--fluent-bg-card);
  }

  .swagger-page-scope .swagger-ui .dialog-ux .modal-ux-header h3 {
    color: var(--fluent-text-primary);
    font-size: 16px;
    font-weight: 700;
  }

  .swagger-page-scope .swagger-ui .dialog-ux .modal-ux-content {
    padding: 16px 20px 20px;
    background: var(--fluent-bg-card);
  }

  .swagger-page-scope .swagger-ui .auth-container .auth-btn-wrapper,
  .swagger-page-scope .swagger-ui .dialog-ux .modal-ux-content .auth-btn-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 12px;
  }

  .swagger-page-scope .swagger-ui .auth-container .auth-btn-wrapper .btn,
  .swagger-page-scope .swagger-ui .dialog-ux .modal-ux-content .auth-btn-wrapper .btn {
    margin: 0;
    min-width: 88px;
  }

  .swagger-page-scope .swagger-ui .dialog-ux .modal-ux-content .btn-done {
    border-color: var(--fluent-brand);
    background: var(--fluent-brand);
    color: #fff;
  }

  .swagger-page-scope .swagger-ui .dialog-ux .modal-ux-content .btn-done:hover {
    border-color: var(--fluent-brand-hover);
    background: var(--fluent-brand-hover);
  }

  .swagger-page-scope .swagger-ui .opblock-tag-section {
    margin-bottom: 10px;
  }

  .swagger-page-scope .swagger-ui .opblock-tag {
    color: var(--fluent-text-primary);
    border-bottom: 1px solid var(--fluent-border);
    margin: 0 0 6px;
    padding: 8px 0;
    font-size: 15px;
    font-weight: 700;
  }

  .swagger-page-scope .swagger-ui .opblock-tag small {
    color: var(--fluent-text-secondary);
    font-size: 12px;
    font-weight: 400;
  }

  .swagger-page-scope .swagger-ui .parameters-col_description p,
  .swagger-page-scope .swagger-ui .response-col_description__inner p,
  .swagger-page-scope .swagger-ui .markdown p,
  .swagger-page-scope .swagger-ui .renderedMarkdown p {
    color: var(--fluent-text-secondary);
    line-height: 1.45;
  }

  .swagger-page-scope .swagger-ui .servers-title,
  .swagger-page-scope .swagger-ui .scheme-container label {
    color: var(--fluent-text-secondary);
  }

  @media (max-width: 900px) {
    .swagger-page-scope .swagger-ui {
      padding: 0 6px 10px;
    }

    .swagger-page-scope .swagger-ui .info {
      padding: 14px 14px;
    }

    .swagger-page-scope .swagger-ui .opblock .opblock-summary {
      min-height: 44px;
    }

    .swagger-page-scope .swagger-ui .opblock .opblock-summary-path {
      font-size: 12px;
    }

    .swagger-page-scope .swagger-ui .info .swagger-info-header {
      flex-direction: column;
      align-items: stretch;
      gap: 6px;
    }

    .swagger-page-scope .swagger-ui .info .swagger-title-controls .scheme-container .schemes {
      justify-content: flex-start;
    }
  }
`;